import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getPermissions } from "../rbac/hasAccess";
import Text from "../../../utils/Custom/text";
import { CancelButton, SaveAndUpdate, UploadButton } from "../../../utils/Custom/Button";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../../global";
import { Autocomplete, TextField } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { toast } from "react-toastify";
import { validateRequiredFields } from "../../../utils/commonComponent/errorAlert";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import { notifiy } from "../../notification/Notification";

const reasonsOptions = [
  { id: "", label: "Select Reason" },
  { id: 2, label: "Family Emergency" },
  { id: 3, label: "Forgot to Punch" },
  { id: 4, label: "Hiring" },
  { id: 5, label: "Medical Reason" },
  { id: 6, label: "New store opening" },
  { id: 7, label: "Not feeling well" },
  { id: 8, label: "Outstation Travelling" },
  { id: 9, label: "Personal" },
  { id: 10, label: "Store Visit" },
  { id: 11, label: "System Error" },
  { id: 12, label: "Training" },
  { id: 13, label: "Warehouse Visit" },
];

const formatDateTime = (date) => {
  if (!date) return null;
  const pad = (n) => (n < 10 ? "0" + n : n);

  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    " " +
    pad(date.getHours()) +
    ":" +
    pad(date.getMinutes()) +
    ":" +
    pad(date.getSeconds())
  );
};

const EditAttendanceRegularization = (props) => {
  const params = useParams();
  const navigate = useNavigate();
  const permissions = getPermissions(props.moduleId);
  const userId = localStorage.getItem("id");
  const [empList, setempList] = useState([]);

  const [inputStates, setInputStates] = React.useState({
    reason: "",
    remark: "",
    punchInDateTime: null,
    punchOutDateTime: null,
    fileULR: "",
  });

  // Update state helper
  const updateInputObject = (key, value) => {
    setInputStates((prev) => ({ ...prev, [key]: value }));
  };

  const handleFileUpload12 = (event, stateKey) => {
    const file = event.target.files[0];
    // added validation only
    if (file && /[&#$*]/.test(file.name)) {
      toast.warning(
        "File name contains special characters. Please rename the file and upload again.",
      );
      return;
    }
    const data = new FormData();
    data.append("fileToUpload", file);
    axiosWithToken
      .post(BASE_URL + `fileUpload/fileUpload.php`, data)
      .then((res) => {
        if (res.status === 200) {
          updateInputObject(stateKey, res.data);
          toast.success("File Uploaded Successfully!");
        }
      })
      .catch(() => toast.error("Something went wrong"));
  };

  // Fetch data when editing
  const getEditData = async () => {
    if (params.id == 0) return;

    try {
      const data = await fetchQuery(
        `SELECT * FROM attendanceRegularization WHERE id=${params.id}`,
      );

      if (data?.length) {
        let row = data[0];

        setInputStates({
          reason: row.reason,
          remark: row.remark,
          punchInDateTime: row.punchInDateTime
            ? new Date(row.punchInDateTime)
            : null,
          punchOutDateTime: row.punchOutDateTime
            ? new Date(row.punchOutDateTime)
            : null,
          fileULR: row.fileULR || "",
        });
      }
    } catch (error) {
      console.error("Error loading edit data:", error);
    }
  };

  const getEmployee = async (employeeID) => {
    try {
      const data = await fetchQuery(
        `SELECT id FROM users WHERE status = 1 and type IN (1, 2, 3)`,
      );
      setempList(data);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
  };

  useEffect(() => {
    getEditData();
    getEmployee();
  }, []);

  // Submit
  const onSubmit = async () => {
    const required = [
      { value: inputStates.reason, label: "Reason is required" },
      {
        value: inputStates.punchInDateTime,
        label: "PunchIn Date Time is required",
      },
      {
        value: inputStates.punchOutDateTime,
        label: "PunchOut Date Time is required",
      },
    ];
    if (!validateRequiredFields(required)) return;

    try {
      const url = BASE_URL + `attendanceRegularization`;

      const finalData = {
        ...inputStates,
        userId: userId,
        punchInDateTime: formatDateTime(inputStates.punchInDateTime),
        punchOutDateTime: formatDateTime(inputStates.punchOutDateTime),
      };

      if (params.id != 0) {
        await axiosWithToken.patch(`${url}/${params.id}`, finalData);
      } else {
        await axiosWithToken.post(url, finalData);
        const notifications = empList.map((emp) => ({
          _from: userId,
          _to: emp.id,
          body: `A new attendance punch correction request has been submitted and is awaiting your review.`,
        }));

        notifiy(notifications, () => {
          console.log("All admins notified");
        });
      }

      toast.success(
        params.id == 0
          ? "Attendance Created Successfully!"
          : "Attendance Updated Successfully!",
      );

      if (params.id == 0) {
        setTimeout(() => navigate("/attendanceRegularizationList"), 800);
      } else {
        setTimeout(() => window.location.reload(), 1000);
      }
    } catch (error) {
      console.error("Submit failed:", error);
    }
  };

  React.useEffect(() => {
    if (inputStates.punchInDateTime) {
      setInputStates((prev) => ({
        ...prev,
        punchOutDateTime: inputStates.punchInDateTime,
      }));
    }
  }, [inputStates.punchInDateTime]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div>
        <Text variant="h3" bold className="text-blue-600">
          {params.id == 0 ? "Create New Attendance" : "Update Attendance"}
        </Text>
        <br />

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {/* Punch In */}
          <div className="col-span-1">
            <DateTimePicker
              format="dd/MM/yyyy hh:mm a"
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                  onKeyDown: (e) => e.preventDefault(),
                },
              }}
              label="Punch In"
              value={inputStates.punchInDateTime}
              onChange={(newValue) =>
                updateInputObject("punchInDateTime", newValue)
              }
              maxDate={new Date()}
            />
          </div>

          {/* Punch Out */}
          <div className="col-span-1">
            <DateTimePicker
              format="dd/MM/yyyy hh:mm a"
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                  onKeyDown: (e) => e.preventDefault(),
                },
              }}
              label="Punch Out"
              value={inputStates.punchOutDateTime}
              onChange={(newValue) =>
                updateInputObject("punchOutDateTime", newValue)
              }
              renderInput={(params) => <TextField {...params} size="small" />}
              minDate={inputStates.punchInDateTime}
              maxDate={inputStates.punchInDateTime}
            />
          </div>

          {/* Reason */}
          <div className="col-span-1">
            <Autocomplete
              size="small"
              value={
                reasonsOptions.find((opt) => opt.label == inputStates.reason) ||
                null
              }
              id="unit_edit_reason"
              options={reasonsOptions}
              getOptionLabel={(option) => option?.label || ""}
              renderInput={(params) => (
                <TextField {...params} label="Reason" required />
              )}
              onChange={(event, newValue) => {
                updateInputObject("reason", newValue ? newValue.label : "");
              }}
            />
          </div>

          {/* Remark */}
          <div className="col-span-1">
            <TextField
              size="small"
              fullWidth
              multiline
              label="Remark"
              value={inputStates.remark || ""}
              onChange={(e) => updateInputObject("remark", e.target.value)}
            />
          </div>

          {/* File Upload */}
          <div className="col-span-1">
            <UploadButton
              label={"File Attachment"}
              onChange={(e) => handleFileUpload12(e, "fileULR")}
              outline={false}
              fileUrl={inputStates?.fileULR}
              showFile={true}
              onRemove={() => updateInputObject("fileULR", null)}
            />
          </div>
        </div>

        <br />

        {/* Buttons */}
        <div className="flex gap-10 mt-5 justify-end">
          <CancelButton
            label="Cancel"
            outline
            onClick={() => {
              if (window.confirm("Cancel changes?")) {
                navigate(-1);
              }
            }}
          />

          {(permissions.save || permissions.allAccess) && (
            <SaveAndUpdate
              label={params.id == 0 ? "Save" : "Update"}
              onClick={onSubmit}
            />
          )}
        </div>
      </div>
    </LocalizationProvider>
  );
};

export default EditAttendanceRegularization;
